// No navegador não há aviso por push (o site é usado com a tela aberta).
export async function registrarPush() {}
export async function removerPush() {}
export function ouvirToquesPush() { return () => {}; }

export function navegacaoPronta(_ok: boolean) {}
export const temPush = () => false;
export async function avisarAgora(_titulo: string, _corpo: string, _dados: Record<string, any>, _canal?: string) {}
export async function testarAviso(): Promise<{ ok: boolean; msg: string }> { return { ok: false, msg: '' }; }
